import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AssessmentResults from '../components/AssessmentResults';
import Header from '../components/Header';

const PageWrapper = styled.div`
  padding-top: 100px; /* Header height */
  min-height: 100vh;
  background-color: ${props => props.theme.colors.charcoal};
  background-image: url('/assets/patterns/Contours - clipped (dark).svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${props => props.theme.spacing.lg};
`;

const MOCK_RESULTS = {
    results: {
        investment_case: "Flux Dynamics represents a compelling opportunity in warehouse automation. Their 'Swarm-v1' unit solves the critical labor shortage in e-commerce fulfillment with a novel decentralized navigation stack. While the hardware is capital intensive, the 'RaaS' (Robot-as-a-Service) model offers strong recurring revenue potential. The founder team combines rare PhD-level SLAM expertise with logistics veterans.",
        confidence_score: 82,
        vertical_detected: "Robotics / Physical AI",
        gap_map: {
            problem: { score: 9, reason: "Labor turnover in 3PL warehouses is >40%, creating a desperate need for automation. This is a hair-on-fire problem." },
            market: { score: 8, reason: "The Warehouse Automation market is projected to hit $50B by 2028. SOM is well-defined (Tier 2/3 retailers)." },
            whyNow: { score: 7, reason: "LiDAR costs have dropped 10x, and labor costs have risen 20% post-Covid. The timing is fundamentally right." },
            vision: { score: 8, reason: "Clear path from warehouse 'material handling' to broader autonomous logistics network." },

            solution: { score: 7, reason: "Decentralized swarm architecture is unique, but hardware reliability at scale is unproven." },
            defensibility: { score: 9, reason: "Proprietary 'Flux-OS' navigation algorithm is patented and creates a significant data moat." },
            proof: { score: 5, reason: "2 Pilots live, but no paid commercial deployments yet. LOI conversion rate is the key risk." },
            roadmap: { score: 6, reason: "Manufacturing scale-up plan is aggressive; assumes 0 defects which is unrealistic for Gen 1 hardware." },

            team: { score: 9, reason: "Founders are ex-Kiva and ex-Boston Dynamics. Technical pedigree is top 1%." },
            gtm: { score: 4, reason: "Sales cycle for RaaS is long (9-12 months). Pipeline is thin outside of the 2 pilots." },
            competition: { score: 7, reason: "Crowded space (Locus, 6 River), but Flux targets a specific 'brownfield' warehouse niche effectively." },
            financials: { score: 5, reason: "Hardware BOM cost is still too high ($15k/unit). Payback period >24 months creates cash flow drag." }
        },
        investor_questions: [
            { question: "How does your 'Swarm' stack handle edge cases (e.g., wifi dead zones) compared to Locus?", importance: "Critical" },
            { question: "What is the true fully-burdened payback period for a customer switching to RaaS?", importance: "Critical" },
            { question: "Can you manufacture 500 units next year without a Series B?", importance: "High" },
            { question: "Why hasn't the Pilot B converted to a paid contract yet?", importance: "High" },
            { question: "How defensible is the navigation algo vs open source alternatives?", importance: "Medium" },
            { question: "What is your plan to reduce BOM cost below $10k?", importance: "Medium" },
            { question: "Are you selling to the Warehouse Operator or the Brand?", importance: "Medium" }
        ],
        supporting_elements: [
            "World-class technical team (ex-Boston Dynamics)",
            "Strong IP moat around decentralized navigation",
            "Clear, urgent market pull for labor reduction"
        ],
        weaknesses: [
            "Hardware capitalization risk is high",
            "Go-to-market motion is currently undefined",
            "Unit economics are negative at current BOM cost"
        ]
    },
    email: "demo@fluxdynamics.ai"
};

const AssessmentResultsPage = () => {
    const location = useLocation();
    // Use location state if available, otherwise fallback to mock data for dev/preview
    const { results, email } = location.state || MOCK_RESULTS;

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header isDark={true} />
            <PageWrapper>
                <ContentWrapper>
                    <AssessmentResults results={results} email={email} />
                </ContentWrapper>
            </PageWrapper>
        </>
    );
};

export default AssessmentResultsPage;
